<div *ngIf="this.forgotPasawordStatus===3">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow">
            <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
            <div class="sub-text">
                ¿Olvidaste tu contraseña?

                <div class="line-gray"></div>
            </div>
        </div>
    </div>
    <div>
        <div>
            La contraseña de acceso es la clave con la que podrá acceder a manejar su cuenta de servicios en Claro
            Wholesale.
        </div>
        <div class="basicrow m-top-i">
            <label class="label-f">Contraseña Temporal</label>
            <div class="basicrow">

                <input class="inp-f" type="password" [(ngModel)]="this.currentPassword">
            </div>
        </div>
        <div class="basicrow m-top-i">
            <label class="label-f">Nueva Contraseña</label>
            <div class="basicrow">
                <input class="inp-f" maxlength="15" type="password" [(ngModel)]="this.password" (keyup)="onKey($event)">
                <app-password-validator (validatePassword)="validatePassword=$event"></app-password-validator>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <label class="label-f">Confirmar Contraseña</label>
            <div class="basicrow">

                <input class="inp-f" type="password" [(ngModel)]="this.passwordConf">
            </div>
        </div>
        <!-- <div class="basicrow m-top-i">
            <label class="label-f">Requerimientos de contraseña</label>
            <ul class="label-f">
                <li>Debe tener entre 8 y 10 caracteres</li>
                <li>Al menos una letra minuscula</li>
                <li>Al menos una letra mayuscula</li>
                <li>Al menos dos numeros</li>
                <li>No esta permitido ningun caracter especial o alfanumerico</li>
            </ul>
        </div> -->
        <div class="basicrow m-top-i">
            <a (click)="this.continue();" class="btns red vcenter">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>